import React from 'react';

const EnvApp = () => {
  const env = process.env.REACT_APP_ENV === 'stg' ? 'Staging' : '';

  if (env === '') return null;
  return <div className="badge-appenv badge badge-danger">{env}</div>;
};

export default EnvApp;
